module.exports = __webpack_public_path__ + "static/media/The-Reserves-at-Northville-Ridge-Master-Deed-Bylaws.b6398925.pdf";